// @flow

import Resource from 'speed-js-core/src/api/NestedResource';

export default class NotificationTypeScopesResource extends Resource {
    basePath: string = 'notifications/notification-types/{parent}/scopes/';

    objectPath: string = 'notifications/notification-types/{parent}/scopes/{ident}/';
}
